import { Form, type FormInstance } from 'antd'
import { match } from 'ts-pattern'
import { useLingui } from '@lingui/react/macro'

import MusicStyle from '../../components/MusicStyle'
import AiLyrice from '../../components/AiLyrice'
import { MUSIC_SUPPORTS_AUDIO_WEIGHT } from '../../../../_config/advancedSettings'
import TadTabs from '../../../../_components/Tabs'

import type { MusicGeneratorFormValuesNew } from '@/pages/tad.ai/ai-music-generator/_types/form'

import CreateButton from '@/pages/tad.ai/_components/CreateButton'
import AdvancedSettings from '@/pages/tad.ai/_components/AdvancedSettings'
import StickyFormActionLayout from '@/pages/tad.ai/_components/StickyFormActionLayout'
import { useAiMusicGeneratorStoreFromZustand } from '@/pages/tad.ai/ai-music-generator/_store/createStore'
import { useMusicFormStore } from '@/pages/tad.ai/ai-music-generator/_store/useMusicFormStore'


import { cls } from 'tagged-classnames-free';
export interface CustomFormProps {
  className?: string
  form: FormInstance<MusicGeneratorFormValuesNew>
  generateMusicLoading: boolean
}

const CustomForm = (props: CustomFormProps) => {
  const { className, form, generateMusicLoading } = props
  const customTaskType = Form.useWatch('customTaskType', form) || 'Song'
  const styleMode = Form.useWatch('styleMode', form)
  const { t } = useLingui()
  const {
    lyricsCustomTextareaContent,
    updateLyricsCustomTextareaContent,
    isStream,
  } = useAiMusicGeneratorStoreFromZustand()
  const isUploading = useMusicFormStore((s) => s.ui.isUploading)
  const advancedExpanded = useMusicFormStore((s) => s.prefs.advancedExpanded)
  const setPrefs = useMusicFormStore((s) => s.setPrefs)

  const handleChange = (value: string) => {
    updateLyricsCustomTextareaContent(value)
  }

  return (
    <StickyFormActionLayout
      className={cls`relative w-full ${className}`}
      contentClassName={cls`px-4 md:px-6`}
      actionClassName={cls`px-4 md:px-6`}
      action={
        <CreateButton
          disabled={isStream || isUploading}
          loading={generateMusicLoading}
        />
      }
    >
      <div>
        <Form.Item name='customTaskType' className='-mt-4'>
          <TadTabs
            activeKey={customTaskType}
            className={cls`
              [&_.coco-tabs-tab]:!pb-1
              [&_.coco-tabs-tab]:!text-[18px]
            `}
            items={[
              {
                label: t`Song`,
                key: 'Song',
              },
              {
                label: t`Instrumental`,
                key: 'Instrumental',
              },
            ]}
          />
        </Form.Item>
        {match(customTaskType)
          .with('Song', () => (
            <AiLyrice
              lyrics={lyricsCustomTextareaContent}
              form={form}
              onChangeLyrics={handleChange}
            />
          ))
          .otherwise(() => null)}
        <MusicStyle form={form} />
        {styleMode !== 'reference' && (
          <Form.Item name='advanced' className='mt-6'>
            <AdvancedSettings
              showAudioWeight={MUSIC_SUPPORTS_AUDIO_WEIGHT}
              expanded={advancedExpanded}
              onExpandedChange={(expanded) =>
                setPrefs({ advancedExpanded: expanded })
              }
            />
          </Form.Item>
        )}
      </div>
    </StickyFormActionLayout>
  )
}

export default CustomForm
